import { Icons } from '@vertex-protocol/web-ui';

const RAILS = ['GCash', 'GoTyme Bank', 'Bank Transfer'];

export function NadoEWalletCashInPanel() {
  return (
    <section
      className="bg-surface-2 flex flex-col gap-y-4 rounded-sm p-4"
      aria-label="E-Wallet cash-in"
    >
      <div className="flex items-start gap-x-3">
        <Icons.Wallet className="text-text-secondary mt-0.5 size-5 flex-shrink-0" />
        <div className="flex flex-col gap-y-1">
          <h3 className="text-text-primary text-sm font-medium">
            E-Wallet Cash In
          </h3>
          <p className="text-text-tertiary text-xs">
            GCash and banking rails will be connected here.
          </p>
        </div>
      </div>

      <div className="flex flex-wrap gap-2">
        {RAILS.map((rail) => (
          <span
            key={rail}
            className="border-stroke text-text-secondary rounded-sm border px-2 py-1 text-xs"
          >
            {rail}
          </span>
        ))}
      </div>

      <button
        type="button"
        disabled
        className="bg-surface-3 text-text-tertiary w-full rounded-sm px-3 py-2 text-sm font-medium"
      >
        Coming Soon
      </button>
    </section>
  );
}
